import { render, staticRenderFns } from "./LoanTracking.vue?vue&type=template&id=036385c6&scoped=true&"
import script from "./LoanTracking.vue?vue&type=script&lang=js&"
export * from "./LoanTracking.vue?vue&type=script&lang=js&"
import style0 from "./LoanTracking.vue?vue&type=style&index=0&id=036385c6&lang=scss&scoped=true&"
import style1 from "./LoanTracking.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036385c6",
  null
  
)

export default component.exports